import { Col, Radio, Checkbox, Row, Space, Tooltip, Switch } from "antd";
import React, { useEffect, useState } from "react";
import InputText from "../Input/InputText";
import {
  IconArrowDown,
  IconArrowTop,
  IconDelete,
  IconXmark,
} from "../../../assets/icon";
import { addValueWithDefault } from "../../../utils/functionCommon";

const SelectAnswer = ({
  handleSortUp,
  handleSortDown,
  index,
  listQS,
  setListQS,
  handleDelete,
  typeAnswer,
  valueEdit,
}) => {
  const [statusSwitch, setStatusSwitch] = useState(false);
  const handleDeleteAS = (value) => {
    let arr = listQS[index - 1].listAnswer.filter(
      (item) => item.index !== value
    );
    arr = arr.map((item, index) => {
      if (item.index > 0) {
        return { ...item, index: index + 1 };
      } else return item;
    });
    setListQS(() => {
      const result = listQS.map((item) => {
        if (item.index === index) {
          return {
            ...item,
            listAnswer: arr,
          };
        }
        return item;
      });
      return result;
    });
  };
  useEffect(() => {
    if (listQS.length) {
      if (listQS.find((item) => item.index === index).required === 1) {
        setStatusSwitch(true);
      } else setStatusSwitch(false);
    }
  }, [index, listQS]);
  return (
    <Row>
      <Col span={3} style={{ display: "flex", alignItems: "center" }}></Col>
      <Col span={3}>
        <div className="tdQS">
          <span className="QSnumber">Câu {index}</span>
        </div>
      </Col>
      <Col span={6}>
        <div className="tdQS">
          <textarea
            rows={4}
            className="question"
            placeholder="Nhập câu hỏi"
            value={listQS.find((item) => item.index === index).nameQuestion}
            onChange={(e) => {
              setListQS(() => {
                const result = listQS.map((item) => {
                  if (item.index === index) {
                    return {
                      ...item,
                      nameQuestion: e.target.value,
                    };
                  }
                  return item;
                });
                return result;
              });
            }}
          ></textarea>
        </div>
      </Col>
      <Col span={7}>
        <div className="tdQS">
          <p className="titleAnswer">Radiobox(chọn 1)</p>
          {typeAnswer === "radio" ? (
            <Radio.Group>
              <Space direction="vertical " style={{ width: "100%" }}>
                {listQS[index - 1].listAnswer?.map((item) => {
                  return (
                    <div className="itemQS">
                      <Radio disabled value={item.index}></Radio>
                      <InputText
                        key={item.index}
                        text={item.content}
                        setText={(text) =>
                          setListQS(() => {
                            const listAS = listQS[index - 1].listAnswer?.map(
                              (itemOption) => {
                                if (itemOption.index === item.index) {
                                  return {
                                    ...itemOption,
                                    content: text,
                                  };
                                }
                                return itemOption;
                              }
                            );
                            const result = listQS.map((item) => {
                              if (item.index === index) {
                                return {
                                  ...item,
                                  listAnswer: listAS,
                                };
                              }
                              return item;
                            });
                            return result;
                          })
                        }
                        disable={item.typeAnswers === 1 ? true : false}
                        typeInput={"baseInput borderNone inputQS"}
                        style={{ border: "none" }}
                        placeholder={`Phương án ${
                          !item.typeAnswers ? item.index : "khác"
                        }`}
                      />
                      <IconXmark
                        onClick={() => {
                          handleDeleteAS(item.index);
                        }}
                        className="pointer"
                      />
                    </div>
                  );
                })}
              </Space>
            </Radio.Group>
          ) : (
            <Checkbox.Group style={{ width: "100%" }}>
              <Space direction="vertical" style={{ width: "100%" }}>
                {listQS[index - 1].listAnswer?.map((item) => {
                  return (
                    <div className="itemQS">
                      <Checkbox value={item.index} disabled></Checkbox>
                      <InputText
                        key={item.index}
                        text={item.content}
                        setText={(text) =>
                          setListQS(() => {
                            const listAS = listQS[index - 1].listAnswer?.map(
                              (itemOption) => {
                                if (itemOption.index === item.index) {
                                  return {
                                    ...itemOption,
                                    content: text,
                                  };
                                }
                                return itemOption;
                              }
                            );
                            const result = listQS.map((item) => {
                              if (item.index === index) {
                                return {
                                  ...item,
                                  listAnswer: listAS,
                                };
                              }
                              return item;
                            });
                            return result;
                          })
                        }
                        disable={item.typeAnswers === 1 ? true : false}
                        typeInput={"baseInput borderNone inputQS"}
                        style={{ border: "none" }}
                        placeholder={`Phương án ${
                          !item.typeAnswers ? item.index : "khác"
                        }`}
                      />
                      <IconXmark
                        onClick={() => {
                          handleDeleteAS(item.index);
                        }}
                        className="pointer"
                      />
                    </div>
                  );
                })}
              </Space>
            </Checkbox.Group>
          )}
          <p className="addQS">
            <span
              onClick={() => {
                if (
                  listQS[index - 1].listAnswer.find(
                    (item) => item.typeAnswers === 1
                  )
                ) {
                  const arrNew = addValueWithDefault(
                    listQS[index - 1].listAnswer,
                    {
                      index: listQS[index - 1].listAnswer.length + 1,
                      content: "",
                      typeAnswers: 0,
                    }
                  );
                  setListQS(() => {
                    const result = listQS.map((item) => {
                      if (item.index === index) {
                        return {
                          ...item,
                          listAnswer: arrNew,
                        };
                      }
                      return item;
                    });
                    return result;
                  });
                } else
                  setListQS(() => {
                    const result = listQS.map((item) => {
                      if (item.index === index) {
                        return {
                          ...item,
                          listAnswer: [
                            ...item.listAnswer,
                            {
                              index: listQS[index - 1].listAnswer.length + 1,
                              typeAnswers: 0,
                              content: "",
                            },
                          ],
                        };
                      }
                      return item;
                    });
                    return result;
                  });
              }}
            >
              Thêm phương án
            </span>{" "}
            hoặc{" "}
            <span
              onClick={() => {
                // console.log(listQS[index - 1].listAnswer.length + 1);
                const checkListAS = listQS[index - 1].listAnswer.find(
                  (answer) => (answer.typeAnswers ? true : false)
                );
                if (checkListAS) {
                  return;
                } else {
                  setListQS(() => {
                    const result = listQS.map((item) => {
                      if (item.index === index) {
                        return {
                          ...item,
                          listAnswer: [
                            ...item.listAnswer,
                            {
                              index: listQS[index - 1].listAnswer.length + 1,
                              typeAnswers: 1,
                              content: "Lý do khác",
                            },
                          ],
                        };
                      }
                      return item;
                    });
                    return result;
                  });
                }
              }}
            >
              "Câu trả lời khác"
            </span>
          </p>
        </div>
      </Col>

      <Col span={2}>
        <div className="tdQS btnFuntion">
          <Switch
            checked={listQS.find((item) => item.index === index).required === 1}
            onChange={(value) => {
              setListQS(() => {
                const result = listQS.map((item) => {
                  if (item.index === index) {
                    return {
                      ...item,
                      required: value ? 1 : 0,
                    };
                  }
                  return item;
                });
                return result;
              });
            }}
          />
        </div>
      </Col>
      <Col span={3}>
        <div className="tdQS btnFuntion">
          <span className="pointer ">
            {listQS.length <= 1 ? null : index === 1 ? (
              <IconArrowDown onClick={() => handleSortDown(index)} />
            ) : index === listQS.length ? (
              <IconArrowTop onClick={() => handleSortUp(index)} />
            ) : (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <IconArrowTop
                  style={{ marginBottom: 5 }}
                  onClick={() => handleSortUp(index)}
                />
                <IconArrowDown onClick={() => handleSortDown(index)} />
              </div>
            )}
          </span>

          <span
            className="pointer iconDelete"
            onClick={() => {
              handleDelete(listQS.find((item) => item.index === index));
            }}
          >
            <Tooltip title="Xóa">
              <IconXmark />
            </Tooltip>
          </span>
        </div>
      </Col>
    </Row>
  );
};

export default SelectAnswer;
